import type { Prototype } from "../prototype-types";

export const benHamiltonPrototypes: Prototype[] = [
  {
    id: "bh-fastly-image-optimizer",
    name: "Fastly Image Optimizer Playground",
    path: "/bh/fastly-image-optimizer",
    description:
      "Interactive controls for every Fastly Image Optimizer query parameter, applied live to sample Faire CDN images.",
    owner: "Ben Hamilton",
    createdAt: "2026-09-23",
    lastUpdated: "2026-09-23",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/bh-fastly-image-optimizer.png",
  },
  {
    id: "bh-prepack-selector",
    name: "Prepack Size Run Labels",
    path: "/bh/prepack-selector",
    description:
      "Sample retailer product pages built around real published prepack size run names, comparing today’s prepack selector with labels that show the size run name.",
    owner: "Ben Hamilton",
    createdAt: "2026-09-24",
    lastUpdated: "2026-09-25",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/bh-prepack-selector.png",
  },
  {
    id: "image-upscaling",
    name: "Image Upscaling",
    path: "/bh/image-upscaling",
    description:
      "Displays upscaled vs low-res images in a product details page with an interactive comparison slider.",
    owner: "Ben",
    createdAt: "2026-03-06",
    lastUpdated: "2026-03-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/c4a37f45f67a6a118813e650d4c8c37c1fdb1b8c0f812a92b9164e20084be3c2.png",
    creationTool: "claude-code",
  },
];
